var map = {
	"./add-recipient.svg": 743,
	"./alipay.svg": 744,
	"./amex.svg": 745,
	"./app-logout.svg": 746,
	"./arrow.svg": 747,
	"./bank-deposit.svg": 748,
	"./bank.svg": 749,
	"./calculator.svg": 750,
	"./calendar.svg": 751,
	"./check.svg": 752,
	"./checkbox-off.svg": 753,
	"./checkbox-on.svg": 754,
	"./chevron-back.svg": 755,
	"./chevron-down.svg": 756,
	"./close.svg": 757,
	"./cloud.svg": 758,
	"./credit-card.svg": 759,
	"./cross.svg": 760,
	"./default.svg": 761,
	"./delete.svg": 762,
	"./diners.svg": 763,
	"./discover.svg": 764,
	"./done-filled.svg": 765,
	"./download.svg": 766,
	"./e-mail.svg": 767,
	"./edit.svg": 768,
	"./elo.svg": 769,
	"./email-contact.svg": 770,
	"./email-notify.svg": 771,
	"./email.svg": 772,
	"./error.svg": 773,
	"./eye.svg": 774,
	"./facebook.svg": 775,
	"./fail.svg": 776,
	"./file.svg": 777,
	"./follow.svg": 778,
	"./forward.svg": 779,
	"./hipercard.svg": 780,
	"./how-it-works.svg": 781,
	"./image.svg": 782,
	"./info.svg": 783,
	"./information.svg": 784,
	"./instagram.svg": 785,
	"./jcb.svg": 786,
	"./linkedin.svg": 787,
	"./location.svg": 788,
	"./maestro-old.svg": 789,
	"./maestro.svg": 790,
	"./mastercard-old.svg": 791,
	"./mastercard.svg": 792,
	"./media-notify.svg": 793,
	"./money-delivery.svg": 794,
	"./more.svg": 795,
	"./new-recipient.svg": 796,
	"./panding.svg": 797,
	"./paypal.svg": 798,
	"./phone-call.svg": 799,
	"./phone-notify.svg": 800,
	"./phone.svg": 801,
	"./post-notify.svg": 802,
	"./post.svg": 803,
	"./present.svg": 804,
	"./present_deactive.svg": 805,
	"./process.svg": 806,
	"./profile.svg": 807,
	"./recipients.svg": 808,
	"./refresh.svg": 809,
	"./search.svg": 810,
	"./security-code.svg": 811,
	"./security.svg": 812,
	"./settings.svg": 813,
	"./sms-notify.svg": 814,
	"./sms.svg": 815,
	"./success.svg": 816,
	"./support.svg": 817,
	"./transaction-list.svg": 818,
	"./transfer-money.svg": 819,
	"./twitter.svg": 820,
	"./uk.svg": 821,
	"./unionpay.svg": 822,
	"./users.svg": 823,
	"./verve.svg": 824,
	"./visa.svg": 825,
	"./waiting.svg": 826,
	"./warning.svg": 827,
	"./zoom.svg": 828
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 742;